<template>
  <v-card outlined class="text-right d-flex justify-end">

    <v-simple-table v-if="receipt.CbteTipo === 1">
      <tbody>
      <tr>
        <th class="text-right">Importe Neto Gravado:</th>
        <td>{{ currencyFormat(receipt.ImpNeto) }}</td>
      </tr>
      <tr v-for="itemIva in filterIva(receipt.Iva)" :key="itemIva.Id" >
        <th class="text-right">IVA {{getPorcentajeAlicuota(itemIva.Id)}}%:</th>
        <td>{{ currencyFormat(itemIva.Importe) }}</td>
      </tr>
      <tr>
        <th class="text-right">Importe Otros Tributos:</th>
        <td>{{ currencyFormat(receipt.ImpTrib) }}</td>
      </tr>
      <tr>
        <th class="text-right">Importe Total:</th>
        <td>{{ currencyFormat(receipt.ImpTotal) }}</td>
      </tr>
      </tbody>
    </v-simple-table>

    <v-simple-table v-else>
      <tbody>
      <tr>
        <th class="text-right">Importe Otros Tributos:</th>
        <td>{{ currencyFormat(receipt.ImpTrib) }}</td>
      </tr>
      <tr>
        <th class="text-right">Importe Total:</th>
        <td>{{ currencyFormat(receipt.ImpTotal) }}</td>
      </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</template>

<script>
import CurrencyMixin from "@/modules/afip/mixins/CurrencyMixin";
import IvaMixin from "@/modules/afip/mixins/IvaMixin";

export default {
  name: "TotalesFactura",
  props:{
    receipt: Object
  },
  mixins: [CurrencyMixin, IvaMixin],
  computed:{
    filterIva(){
      return Iva => {
        return Iva.filter(v => v.Id)
      }
    }
  }
}
</script>

<style scoped>

</style>
